const userDetailsLocalStorage = JSON.parse(localStorage.getItem("user"))?.userDetails;

export default userDetailsLocalStorage;